import * as p from '@clack/prompts'
import type { FormColumn, FormSchema } from '@cli-types/core-engine/schema.js'
import { CREATE_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { cancel } from '../schema-prompts/cancel.js'
import { displayLabel } from '../schema-prompts/display-label.js'
import { formColumnTypeForField } from '../schema-prompts/form-column-type-for-field.js'
import { getUserAddedSubmissionColumnFields } from './get-user-added-submission-column-fields.js'

export async function promptFormSubmissionColumns(schema: FormSchema): Promise<void> {
  const fields = getUserAddedSubmissionColumnFields(schema.fields ?? [])
  if (fields.length === 0) {
    schema.columns = []
    return
  }

  const existingColumnNames = schema.columns
    ? new Set(schema.columns.map((column) => column.accessorKey))
    : undefined
  const initialValues = existingColumnNames
    ? fields.filter((field) => existingColumnNames.has(field.name)).map((field) => field.name)
    : fields.map((field) => field.name)
  const selected = await p.multiselect<string>({
    message: 'Submission table columns',
    options: fields.map((field) => ({
      value: field.name,
      label: displayLabel(field)
    })),
    initialValues,
    required: false
  })

  if (p.isCancel(selected)) {
    cancel(CREATE_PROMPT_CONTEXT)
  }

  const selectedNames = new Set(selected as string[] | undefined)
  schema.columns = fields
    .filter((field) => selectedNames.has(field.name))
    .map((field): FormColumn => {
      const type = formColumnTypeForField(field)
      return {
        accessorKey: field.name,
        header: displayLabel(field),
        ...(type ? { type } : {})
      }
    })
}
